import { Pdf } from "shared/datamodel/schemas/pdf";
import { BaseElementController, ElementController } from "elements/base/controller";
import { BoardContext } from "..";
import { equals } from "rambda";

export interface IPdfController extends ElementController<Pdf> {
  getCurrentPage: () => number;
  getTotalPages: () => number;
  setCurrentPage: (page: number) => void;
  isLoading: () => boolean;
  isPageLocked: () => boolean;
  getDisplayPage: () => number;
}

export default class PdfController extends BaseElementController<Pdf> implements IPdfController {
  public getCurrentPage(): number {
    return this.element.currentPage;
  }

  public getTotalPages(): number {
    return this.element.totalPages;
  }

  public isPageLocked(): boolean {
    return this.element.pageToDisplay !== undefined;
  }

  public getDisplayPage(): number {
    return this.element.pageToDisplay || this.element.currentPage;
  }

  public setCurrentPage(page: number): void {
    if (this.isPageLocked()) {
      console.warn("Cannot change page when pageToDisplay is set");
      return;
    }

    if (page >= 1 && page <= this.element.totalPages) {
      this.patchElement(this.id, (draft: Pdf) => {
        draft.currentPage = page;
      });
    }
  }

  public getPdfName(): string {
    return this.element.customName || "";
  }

  public isLoading(): boolean {
    return this.element.uploadStatus === "in-progress";
  }

  updateContext(context: BoardContext): void {
    super.updateContext(context);
  }

  updateElement(element: Pdf): void {
    // eslint-disable-next-line unicorn/consistent-function-scoping
    const makeElement = () => {
      return {
        currentPage: this.element.currentPage,
        totalPages: this.element.totalPages,
        uploadStatus: this.element.uploadStatus,
        fileId: this.element.fileId,
        pageToDisplay: this.element.pageToDisplay,
      };
    };

    const oldElement = makeElement();
    super.updateElement(element);
    const newElement = makeElement();

    if (!equals(oldElement, newElement)) {
      this.notify();
    }
  }

  getLayoutRect(): { x: number; y: number; width: number; height: number } {
    return { x: this.element.x, y: this.element.y, width: this.element.width, height: this.element.height };
  }
}
